import _ from 'lodash';

import React from 'react';
import API from '../services/api.js';
import { Dropdown, Segment } from 'semantic-ui-react';
import { AvailableSymbols } from './index';


class Symbols extends React.Component {
	constructor (props) {
		super(props);

		this.state = {
			symbol: props.symbol,
			symbols: [],
			selectedSymbol: props.symbol,
			ticker: null,
			availableSymbols: []
		}
	}
	selectSymbol = (event, { value }) => {
		this.setState({
			selectedSymbol: value
		});

		this.props.changeSymbol(value);
	}
	componentDidMount () {
		API.Symbol.list()
			.then(({ result: symbols }) => {
				symbols = _.map(symbols, symbol => ({
					key: symbol.symbol,
					value: symbol.symbol,
					text: symbol.symbol
				}));

				this.setState({
					symbols,
				})
			})
			.catch(err => {
				console.error(err);
			})
		API.Symbol.active()
			.then(({ symbols: availableSymbols, }) => {
				this.setState({
					availableSymbols
				})
			})
			.catch(err => {
				console.error(err);
			})

		if (!this.state.ticker) {
			this.updateList();
		}
	}

	updateList() {
		this.setState({
			ticker: setTimeout(() => {
				API.Symbol.active()
					.then(({ symbols: availableSymbols, }) => {
						this.setState({
							availableSymbols
						})
					})
					.catch(err => {
						console.error(err);
					})
					.finally(() => {
						this.updateList();
					})
			}, 2000)
		});
	}

	componentWillUnmount () {
		const { ticker } = this.state;

		clearInterval(ticker);

		this.setState({
			ticker: null
		});
	}

	/*componentDidUpdate (prevProps) {
		if (this && this.props.symbol !== prevProps.symbol) {
			this.setState({
				symbol: this.props.symbol,
				selectedSymbol: this.props.symbol
			});
		}
	}*/

	render () {
		const { symbol, symbols, selectedSymbol, availableSymbols } = this.state;

		return (
			<>
			<Segment>
				<AvailableSymbols symbol={symbol} changeSymbol={this.props.changeSymbol} symbols={availableSymbols}/>
			</Segment>
			<Dropdown
				placeholder='Выберите пару'
				fluid
				search
				selection
				options={symbols}
				clearable
				value={selectedSymbol}
				onChange={this.selectSymbol}
			/>
			</>
		)
	}
}

export default Symbols;

